import {DEFAULT_TIMEZONE} from 'helpers/constants';
import {userActionTypes} from 'actions/actionTypes';
import {handleLoading} from '../helpers/reduxHelpers';

const initialState = {
  loading: {
    timezone: true,
    userPreference: false,
    userPreferences: true,
    token: true,
  },
  preferences: {},
  timezone: DEFAULT_TIMEZONE,
  tokenData: {},
  userRole: 100,
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case userActionTypes.TOKEN.COMPLETE: {
      if (action.error) {
        return {...state, tokenData: {}};
      }

      const userRole = Number(action.payload['role']);

      return {
        ...state,
        tokenData: action.payload,
        userRole: Number.isNaN(userRole) ? 100 : userRole,
      };
    }

    case userActionTypes.TOKEN.LOADING:
    case userActionTypes.TIMEZONE.LOADING:
    case userActionTypes.USER_PREFERENCE.LOADING:
    case userActionTypes.UPDATE_USER_PREFERENCE.LOADING:
      return {
        ...state,
        loading: handleLoading(state.loading, action),
      };

    case userActionTypes.TIMEZONE.COMPLETE:
    case userActionTypes.USER_PREFERENCE.COMPLETE:
      return action.stateField
        ? {
            ...state,
            loading: handleLoading(state.loading, {
              field: action.field,
              loading: false,
            }),
            [action.stateField]: action.payload,
          }
        : state;

    case userActionTypes.UPDATE_USER_PREFERENCE.COMPLETE:
      return {
        ...state,
        loading: handleLoading(state.loading, {
          field: action.field,
          loading: false,
        }),
        preferences: {
          ...state.preferences,
          [action.stateField]: action.payload,
        },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js